import { defineMessages } from 'react-intl';
import { isBlank } from 'helpers/verify';
import { MIN_AGE } from 'constants/video';

const messages = defineMessages({
  invalidDate: {
    id: 'validators.dateOfBirth.invalidDateFormat',
    defaultMessage: 'Please provide a valid date format (YYYY-MM-DD).',
  },
  invalidBirthDate: {
    id: 'validators.dateOfBirth.invalidBirthDate',
    defaultMessage: 'Sorry, you must be at least 18 years old.',
  },
});

export const dateOfBirthValidator = val => {
  if (isBlank(val)) {
    return messages.invalidDate;
  }

  if (!val.match(/^\d\d\d\d-\d\d-\d\d$/)) {
    return messages.invalidDate;
  }

  const dateOfBirth = new Date(val);
  if (!dateOfBirth.getDate()) {
    return messages.invalidDate;
  }

  const dateOfBirthThreshold = new Date();
  dateOfBirthThreshold.setFullYear(dateOfBirthThreshold.getFullYear() - MIN_AGE);

  if (dateOfBirthThreshold < dateOfBirth) {
    return messages.invalidBirthDate;
  }
};
